import { Navigate, useLocation } from 'react-router-dom';

const LEGACY_PORTFOLIO_REDIRECTS: Record<string, string> = {
  '/portfolio-engineering/manage': '/portfolio/portfolio-construction/rebalancer',
  '/portfolio-engineering/manage/rebalance': '/portfolio/portfolio-construction/rebalancer',
  '/portfolio-engineering/manage/compliance': '/operations/compliance/approvals-and-policies',
  '/portfolio-engineering/manage/reporting': '/portfolio/portfolio-construction/attribution',
  '/portfolio-engineering/research': '/research/tools/back-tester',
  '/portfolio-engineering/research/back-tester': '/research/tools/back-tester',
  '/portfolio-engineering/research/models': '/research/tools/models',
  '/portfolio-engineering/entities/benchmarks': '/research/data-management/benchmarks',
  '/portfolio-engineering/entities/risk-models': '/research/data-management/factor-models',
  '/portfolio-engineering/entities/ts': '/research/data-management/time-series',
  '/portfolio-engineering/entities/universes': '/research/data-management/universes',
  '/portfolio-engineering/setup/jobs': '/admin/advanced-portfolio/jobs',
  '/portfolio-engineering/setup/iam': '/admin/advanced-portfolio/permissions',
};

export function LegacyPortfolioRedirect() {
  const { pathname } = useLocation();
  return <Navigate to={LEGACY_PORTFOLIO_REDIRECTS[pathname] ?? '/portfolio'} replace />;
}
